"use client";
import { jsx } from "react/jsx-runtime";
import { cn } from "../utils.js";
import * as __rspack_external_react from "react";
import * as __rspack_external__radix_ui_react_popover_c8444160 from "@radix-ui/react-popover";
const Popper = __rspack_external__radix_ui_react_popover_c8444160.Root;
const PopperTrigger = __rspack_external__radix_ui_react_popover_c8444160.Trigger;
const PopperAnchor = __rspack_external__radix_ui_react_popover_c8444160.Anchor;
const PopperClose = __rspack_external__radix_ui_react_popover_c8444160.Close;
const PopperContent = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, align = 'center', sideOffset = 4, removePadding, removePortal, ...props }, ref)=>{
    const Wrapper = removePortal ? __rspack_external_react.Fragment : __rspack_external__radix_ui_react_popover_c8444160.Portal;
    return /*#__PURE__*/ jsx(Wrapper, {
        children: /*#__PURE__*/ jsx(__rspack_external__radix_ui_react_popover_c8444160.Content, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: cn('tw-z-[16000010] tw-rounded tw-outline-none data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2 tw-m-1', 'tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-04 dark:tw-text-neutral-light-100', 'tw-shadow-03 dark:tw-shadow-none', !removePadding && 'tw-px-2 tw-py-2.4', className),
            ...props
        })
    });
});
PopperContent.displayName = __rspack_external__radix_ui_react_popover_c8444160.Content.displayName;
export { Popper, PopperAnchor, PopperClose, PopperContent, PopperTrigger };
